export default "__VITE_ASSET__XWDPSszb__"